import react from 'react';
import { Tooltip } from "antd";

export default function ({ title, ...props }) {
    return (
        <Tooltip title={title} color="#262626" {...props}>
            {props.children}
        </Tooltip>
    )
}